import React from 'react';
import { Link, useParams } from 'react-router-dom';
import MarketingShell from '../../components/MarketingShell';
import HtmlBody from '../../components/HtmlBody';
import blogPosts from '../../data/marketing/blogPosts.json';

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = blogPosts.find((item) => item.slug === slug && !item.isDraft);

  if (!post) {
    return (
      <MarketingShell title="Post not found">
        <p className="text-sm text-gray-600">This article is not available.</p>
        <Link to="/blog" className="mt-4 inline-block text-sm font-medium text-gray-900">
          Back to blog
        </Link>
      </MarketingShell>
    );
  }

  return (
    <MarketingShell>
      <article className="rounded-xl border border-gray-100 bg-white p-6">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-500">Blog</p>
        <h1 className="mt-2 text-xl font-semibold tracking-tight text-gray-900">{post.name}</h1>
        {post.mainImage?.url ? (
          <img
            src={post.mainImage.url}
            alt={post.mainImage.alt || post.name}
            className="mt-6 w-full rounded-lg border border-gray-100"
          />
        ) : null}
        <div className="mt-6">
          <HtmlBody html={post.body} />
        </div>
      </article>
    </MarketingShell>
  );
}
